"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var public_export_passcode_html_1 = __importDefault(require("./public-export-passcode.html"));
(function (module) {
    'use strict';
    module.factory('prPublicExportPasscodeModal', [
        'qstrap.modal',
        function (modal) {
            var passcodeModal;
            function show() {
                passcodeModal = modal({
                    show: true,
                    controller: 'prPublicExportPasscodeController',
                    title: '<span translate>PASSCODE_PROTECTED_REPORT </span>',
                    contentTemplate: public_export_passcode_html_1.default,
                    buttons: [
                        '<button class="btn" ng-click="close();" translate> CANCEL</button>',
                        '<button class="btn btn-success" ng-click="$ctrl.submitPasscode();" ' +
                            'qstrap.spin spin-cover="hide" spin-if="$ctrl.pending" ' +
                            'ng-disabled="!$ctrl.passcode.length"> <span translate> SUBMIT </span></button>'
                    ]
                });
            }
            function close() {
                passcodeModal.close();
            }
            return {
                show: show,
                close: close
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
